import { Injectable } from '@angular/core';
import { ConfigService } from '../config/config.service';
import { TenantService } from '@bo-client/core/api/tenant.service';
import { DataShareService } from '@bo-client/shared/services/data-share.service';
import { HttpClient } from '@angular/common/http';
import { AuthenticationService } from '@bo-client/core';

@Injectable()
export class InitializationService {
  constructor(
    private configService: ConfigService,
    private tenantService: TenantService,
    private authenticationService: AuthenticationService,
    private dataShareService: DataShareService,
    private httpClient: HttpClient
  ) {}

  public init(): Promise<any> {
    return new Promise<void>((resolveFn, rejectFn) => {
      this.httpClient.get('./assets/config.json').subscribe((settings) => {
        this.configService.init(settings);
        console.log('got settings', settings);
        this.tenantService.getTenant().subscribe((tenant) => {
          console.log('got tenant', tenant);
          this.dataShareService.setTenant(tenant);
          // isLoggedIn
          if (this.authenticationService.isLoggedIn) {
            console.log('loading user data');
            this.authenticationService.loadUserData().subscribe((onDone) => {
              resolveFn();
            });
          } else {
            resolveFn();
          }
        });
      });
    });
  }
}
